export default __webpack_public_path__ + "static/media/check-circle.f027ab5d.svg";